module.exports = __webpack_public_path__ + "img/detail-ex.17d6fff1.png";